import MasonryGrid from './masonry-grid'
import MasonryGridQuery from './masonry-grid.query'

export { MasonryGridQuery }
export default MasonryGrid
